import { render, staticRenderFns } from "./TraitsBlock.vue?vue&type=template&id=6ab5a130&"
import script from "./TraitsBlock.vue?vue&type=script&lang=js&"
export * from "./TraitsBlock.vue?vue&type=script&lang=js&"
import style0 from "./TraitsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports